
const state = {
	token: '',
	user: null,
	notificationCount: 0,
	messageCount: 0,
	company: null,
	position: '',
	profile: '',
	sessionType: '',
	userPackage: null,
	sectorAdded: true,
	hasAdmin: false,
	isAdmin: false,
	userPackageStatus: 'no_package',
	companyUserStatus: 'new',
	packageLimits: [],
	country: '', // Initialize with an empty string or default value
}

// getters
const getters = {
	getCountry: (state) => state.country,

}

// mutations
const mutations = {

	setToken: (state, payload) => {
		state.token =  payload;
	},

	setUser: (state, payload) => {
		state.user =  payload;
	},
	setNotificationCount: (state, payload) => {
		state.notificationCount =  payload;
	},
	setMessageCount: (state, payload) => {
		state.messageCount =  payload;
	},
	setCompany: (state, payload) => {
		state.company =  payload;
	},
	setPosition: (state, payload) => {
		state.position =  payload;
	},
	setProfile: (state, payload) => {
		state.profile =  payload;
	},
	setSessionType: (state, payload) => {
		state.sessionType =  payload;
	},
	setUserPackage: (state, payload) => {
		state.userPackage =  payload;
	},

	setUserPackageStatus: (state, payload) => {
		state.userPackageStatus =  payload;
	},

	setPackageLimits: (state, payload) => {
		state.packageLimits =  payload;
	},
	setSectorAdded: (state, payload) => {
		state.sectorAdded =  payload;
	},
	setHasAdmin: (state, payload) => {
		state.hasAdmin =  payload;
	},
	setIsAdmin: (state, payload) => {
		state.isAdmin =  payload;
	},
	setCompanyUserStatus: (state, payload) => {
		state.companyUserStatus =  payload;
	},
	setCountry: (state, country) => {
		state.country = country;
	},
}

// actions
const actions = {
	setUser: (context, payload) => {
		context.commit('setUser', payload)
	},
	setNotificationCount: (context, payload) => {
		context.commit('setNotificationCount', payload)
	},
	setMessageCount: (context, payload) => {
		context.commit('setMessageCount', payload)
	},
	setToken: (context, payload) => {
		context.commit('setToken', payload)
	},
	setCompany: (context, payload) => {
		context.commit('setCompany', payload)
	},
	setPosition: (context, payload) => {
		context.commit('setPosition', payload)
	},
	setProfile: (context, payload) => {
		context.commit('setProfile', payload)
	},
	setSessionType: (context, payload) => {
		context.commit('setSessionType', payload)
	},
	setUserPackage: (context, payload) => {
		context.commit('setUserPackage', payload)
	},
	setUserPackageStatus: (context, payload) => {
		context.commit('setUserPackageStatus', payload)
	},
	setPackageLimits: (context, payload) => {
		context.commit('setPackageLimits', payload)
	},
	setSectorAdded: (context, payload) => {
		context.commit('setSectorAdded', payload)
	},
	setHasAdmin: (context, payload) => {
		context.commit('setHasAdmin', payload)
	},
	setIsAdmin: (context, payload) => {
		context.commit('setIsAdmin', payload)
	},
	setCompanyUserStatus: (context, payload) => {
		context.commit('setCompanyUserStatus', payload)
	},
	setCountry: (context, country) => {
		context.commit('setCountry', country);
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}